import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Context } from '../Cart'
import { getSummaryClassicCart } from '../../../../controller/api/__classic__/cart'
import { useCookies } from 'react-cookie';
import CartTicketSummary from '../../components/CartTicketSummary'

const _Summary = ({ region }) => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [summary, setSummary] = useState({
    total: 0,
    data: []
  })

  const getSummaryFunc = useCallback(async () => {

    const response = await getSummaryClassicCart(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      isDone: 1,
      phone: state.filter.phone,
      region: region
    })

    if (response) {
      setSummary({
        total: response.total,
        data: response.data || []
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, region])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <CartTicketSummary total={summary.total} data={summary.data} />
  );
};

export default _Summary
